import { defineStore } from 'pinia';
import { reactive } from 'vue';

export interface ToastMessage {
  id: string;
  title?: string;
  message: string;
  variant: 'info' | 'success' | 'warning' | 'error';
  timeoutMs: number;
}

const DEFAULT_TIMEOUT = 4000;

const generateId = () => `toast-${Math.random().toString(36).slice(2, 10)}`;

export const useToastStore = defineStore('toast', () => {
  const messages = reactive<ToastMessage[]>([]);

  const addToast = (input: { message: string; variant?: ToastMessage['variant']; title?: string; timeoutMs?: number }) => {
    const id = generateId();
    const toast: ToastMessage = {
      id,
      message: input.message,
      title: input.title,
      variant: input.variant ?? 'info',
      timeoutMs: input.timeoutMs ?? DEFAULT_TIMEOUT
    };

    messages.push(toast);

    window.setTimeout(() => removeToast(id), toast.timeoutMs);
  };

  const removeToast = (id: string) => {
    const index = messages.findIndex((toast) => toast.id === id);
    if (index !== -1) {
      messages.splice(index, 1);
    }
  };

  return {
    messages,
    addToast,
    removeToast
  };
});

